import type { UserSummary } from '@cult/schemas';
import { Card, Divider, Flex, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';
import { CopyLinkButton, UserAvatar, UserChip } from '../../../../components';
import styles from './InteractionDetailAside.module.scss';

const { Title, Text } = Typography;

type Props = {
  author: UserSummary;
  receiver: UserSummary;
  createdAt: string | Date;
  receiverLabel: string;
};

export const InteractionDetailAside = ({ author, receiver, createdAt, receiverLabel }: Props) => (
  <>
    <Card styles={{ body: { padding: 20 } }}>
      <Flex vertical align="center" gap={4} style={{ marginBottom: 16 }}>
        <UserAvatar size={72} avatarUrl={receiver.avatarUrl} />
        <Text type="secondary" strong className={styles.receiverLabel}>
          {receiverLabel}
        </Text>
        <Title level={4} style={{ margin: 0, textAlign: 'center' }}>
          {receiver.displayName}
        </Title>
      </Flex>

      <Divider style={{ margin: '0 0 14px' }} />

      <Flex vertical gap={12}>
        <Flex align="center" justify="space-between" gap={12}>
          <Text type="secondary" className={styles.meta}>
            From
          </Text>
          <UserChip user={author} size={20} />
        </Flex>
        <Flex align="center" justify="space-between" gap={12}>
          <Text type="secondary" className={styles.meta}>
            Posted
          </Text>
          <Tooltip title={dayjs(createdAt).format('MMM D, YYYY h:mm A')}>
            <Text type="secondary" className={styles.meta}>
              {dayjs(createdAt).format('MMM D, YYYY')}
            </Text>
          </Tooltip>
        </Flex>
      </Flex>
    </Card>

    <Flex justify="center">
      <CopyLinkButton />
    </Flex>
  </>
);
